export const INDUSTRY_CATEGORY_OPTIONS = [
  { value: "home_services", label: "Home services" },
  { value: "professional_services", label: "Professional services" },
  { value: "healthcare", label: "Healthcare" },
  { value: "other", label: "Other" },
];

export const EXPECTED_DEPLOYS_90D_OPTIONS = [
  { value: "1", label: "1 client" },
  { value: "2-5", label: "2–5 clients" },
  { value: "6+", label: "6+ clients" },
];

export const AI_EMPLOYEE_CAPABILITY_OPTIONS = [
  { value: "lead_capture", label: "Lead capture (name, phone, email)" },
  { value: "qualification", label: "Qualification questions" },
  { value: "booking", label: "Booking / scheduling" },
  { value: "faq_pricing", label: "FAQ / pricing ranges" },
  { value: "crm_handoff", label: "CRM handoff" },
  { value: "human_handoff", label: "Human handoff" },
];

export const REQUEST_STATUS_LABELS = {
  submitted: "Submitted",
  in_review: "In review",
  approved: "Approved",
  declined: "Declined",
};

export const REQUEST_STATUS_STYLES = {
  submitted: "bg-white/5 text-partner-muted border-partner",
  in_review: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  declined: "bg-red-500/10 text-red-400 border-red-500/30",
};

export const getIndustryLabel = (value) =>
  INDUSTRY_CATEGORY_OPTIONS.find((o) => o.value === value)?.label || value;
